export const categories = [
  {
    id: 'japanese-movie',
    name: '日本电影',
    slug: 'japanese-movie',
    description: '最新最全的日本电影免费在线观看，涵盖爱情、动作、悬疑、动画等多种类型',
    icon: 'ri-sun-line',
  },
  {
    id: 'korean-movie',
    name: '韩国电影',
    slug: 'korean-movie',
    description: '韩国电影高清免费在线观看，最新大片、经典韩影一网打尽',
    icon: 'ri-star-line',
  },
  {
    id: 'romance',
    name: '爱情片',
    slug: 'romance',
    description: '日韩浪漫爱情电影，感动人心的纯爱故事',
    icon: 'ri-heart-line',
  },
  {
    id: 'action',
    name: '动作片',
    slug: 'action',
    description: '热血激燃的日韩动作大片，震撼视觉体验',
    icon: 'ri-fire-line',
  },
  {
    id: 'suspense',
    name: '悬疑片',
    slug: 'suspense',
    description: '烧脑悬疑日韩电影，层层反转扣人心弦',
    icon: 'ri-movie-line',
  },
  {
    id: 'animation',
    name: '动画片',
    slug: 'animation',
    description: '日韩经典动画电影，精美画面治愈人心',
    icon: 'ri-emotion-line',
  },
  {
    id: 'comedy',
    name: '喜剧片',
    slug: 'comedy',
    description: '日韩爆笑喜剧电影，欢乐解压必备',
    icon: 'ri-emotion-happy-line',
  },
  {
    id: 'horror',
    name: '恐怖片',
    slug: 'horror',
    description: '日韩经典恐怖电影，挑战你的胆量极限',
    icon: 'ri-ghost-line',
  },
];

export const movies = [
  {
    id: 'movie-1',
    slug: 'your-name',
    title: '你的名字',
    titleEn: 'Your Name',
    category: 'animation',
    region: 'japanese-movie',
    year: 2016,
    rating: 9.2,
    duration: '106分钟',
    director: '新海诚',
    actors: ['神木隆之介', '上白石萌音'],
    description: '在远离大都会的小山村，住着巫女世家出身的高中女孩宫水三叶。校园和家庭的原因让她充满烦恼，而近一段时间发生的奇怪事件，又让三叶摸不清头脑。不知从何时起，三叶在梦中就会变成一个住在东京的高中男孩。那里有陌生的同学和朋友，有亲切的前辈和繁华的街道，一切都是如此诱人而真实。另一方面，住在东京的高中男孩立花泷则总在梦里来到陌生的小山村，以女孩子的身份过着全新的生活。两人就这样在梦中邂逅了彼此。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20style%2C%20romantic%20fantasy%20with%20comet%20and%20starry%20night%20sky%2C%20two%20teenagers%20reaching%20out%20to%20each%20other%2C%20warm%20golden%20and%20purple%20twilight%20tones%2C%20cinematic%20lighting%2C%20emotional%20atmosphere%2C%20clean%20composition%2C%20minimalist%20Japanese%20aesthetic&width=600&height=850&seq=movie-your-name&orientation=portrait',
    tags: ['动画', '爱情', '奇幻', '治愈'],
    isHot: true,
    isNew: false,
    isClassic: true,
    featured: true,
  },
  {
    id: 'movie-2',
    slug: 'parasite',
    title: '寄生虫',
    titleEn: 'Parasite',
    category: 'suspense',
    region: 'korean-movie',
    year: 2019,
    rating: 9.3,
    duration: '132分钟',
    director: '奉俊昊',
    actors: ['宋康昊', '李善均', '赵汝贞', '崔宇植'],
    description: '基宇出生在一个贫穷的家庭之中，和妹妹基婷以及父母在狭窄的地下室里过着相依为命的日子。一天，基宇的同学上门拜访，他告诉基宇，自己在一个有钱人家里给他们的女儿做家教，太太是一个头脑简单出手又阔绰的女人，因为自己要出国留学，所以将家教的职位暂时转交给基宇。就这样，基宇来到了朴社长家中，并且见到了他的太太。没过多久，基宇的妹妹和父母也如同寄生虫一般的进入了朴社长家里工作。然而，他们的野心并没有止步于此，基宇更是和大小姐坠入了爱河。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20movie%20poster%20style%2C%20dark%20mysterious%20atmosphere%2C%20contrast%20between%20rich%20and%20poor%2C%20modern%20architecture%20and%20basement%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20tense%20mood%2C%20minimalist%20design%20with%20striking%20visual%20metaphor&width=600&height=850&seq=movie-parasite&orientation=portrait',
    tags: ['悬疑', '剧情', '社会', '黑色幽默'],
    isHot: true,
    isNew: false,
    isClassic: true,
    featured: true,
  },
  {
    id: 'movie-3',
    slug: 'spirited-away',
    title: '千与千寻',
    titleEn: 'Spirited Away',
    category: 'animation',
    region: 'japanese-movie',
    year: 2001,
    rating: 9.4,
    duration: '125分钟',
    director: '宫崎骏',
    actors: ['柊瑠美', '入野自由', '夏木真理'],
    description: '千寻和爸爸妈妈一同驱车前往新家，在郊外的小路上不慎进入了神秘的隧道，来到了一个诡异的世界。在这个世界，不劳动的人会被变成动物。千寻的爸爸妈妈因贪吃变成了猪，千寻为了救爸爸妈妈，在汤婆婆的浴场里工作，经历了很多磨难。期间她遇见了白龙，一个既聪明又冷酷的少年。在经历了各种事情之后，千寻最终救出了爸爸妈妈，也拯救了白龙。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20Studio%20Ghibli%20style%2C%20magical%20bathhouse%20spirit%20world%2C%20young%20girl%20in%20red%20traditional%20clothing%2C%20mysterious%20dragon%20boy%2C%20fantasy%20atmosphere%2C%20warm%20rich%20colors%2C%20intricate%20details%2C%20dreamlike%20Japanese%20aesthetic&width=600&height=850&seq=movie-spirited&orientation=portrait',
    tags: ['动画', '奇幻', '冒险', '成长'],
    isHot: false,
    isNew: false,
    isClassic: true,
    featured: true,
  },
  {
    id: 'movie-4',
    slug: 'oldboy',
    title: '老男孩',
    titleEn: 'Oldboy',
    category: 'suspense',
    region: 'korean-movie',
    year: 2003,
    rating: 8.9,
    duration: '120分钟',
    director: '朴赞郁',
    actors: ['崔岷植', '刘智泰', '姜惠贞'],
    description: '女儿生日那天，中年男子吴大修在醉酒回家路上，突遭不明身份的人绑架失踪。就此，他毫无理由地被囚禁在一个神秘的私人监狱中。寻死不成之后，他每天看电视，三餐吃煎饺。通过电视，他得知妻子已遭杀害，女儿下落不明，而自己更被怀疑为凶手。就此，吴大修开始锻炼身体，决心复仇，并在牢中度过漫长的15年。当吴大修秘密挖通墙壁时，却在某一天被释放，他被放出后，不顾一切地寻找自己被绑架囚禁的原因，展开了疯狂的复仇计划。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20thriller%20movie%20poster%2C%20dark%20noir%20style%2C%20intense%20mood%2C%20mysterious%20man%20silhouette%2C%20rainy%20urban%20night%2C%20red%20accents%20on%20dark%20background%2C%20brutal%20yet%20artistic%20composition%2C%20minimalist%20Korean%20cinema%20aesthetic&width=600&height=850&seq=movie-oldboy&orientation=portrait',
    tags: ['悬疑', '复仇', '惊悚', '剧情'],
    isHot: false,
    isNew: false,
    isClassic: true,
    featured: false,
  },
  {
    id: 'movie-5',
    slug: 'weathering-with-you',
    title: '天气之子',
    titleEn: 'Weathering With You',
    category: 'animation',
    region: 'japanese-movie',
    year: 2019,
    rating: 8.6,
    duration: '112分钟',
    director: '新海诚',
    actors: ['醍醐虎汰朗', '森七菜'],
    description: '高一那年夏天，帆高离开位在离岛的家乡，独自一人来到东京。拮据的生活迫使他不得不找份工作，最后来到一间专门出版奇怪超自然刊物的出版社担任写手。不久，东京开始下起连日大雨，仿佛暗示着帆高不顺遂的未来。在这座繁忙城市里到处取材的帆高邂逅了与弟弟相依为命、不可思议的美少女阳菜。「等等就会放晴了喔。」阳菜这样告诉着帆高。不久，头顶的乌云逐渐散去，耀眼的阳光洒落街道。原来，阳菜拥有「改变天气」的奇妙能力。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%2C%20romantic%20fantasy%2C%20rainy%20Tokyo%20cityscape%2C%20girl%20with%20supernatural%20weather%20power%2C%20sunlight%20breaking%20through%20dark%20clouds%2C%20beautiful%20sky%2C%20emotional%20young%20couple%2C%20vibrant%20color%20contrast%2C%20cinematic%20Makoto%20Shinkai%20style&width=600&height=850&seq=movie-weather&orientation=portrait',
    tags: ['动画', '爱情', '奇幻', '青春'],
    isHot: true,
    isNew: false,
    isClassic: false,
    featured: false,
  },
  {
    id: 'movie-6',
    slug: 'train-to-busan',
    title: '釜山行',
    titleEn: 'Train to Busan',
    category: 'action',
    region: 'korean-movie',
    year: 2016,
    rating: 8.5,
    duration: '118分钟',
    director: '延尚昊',
    actors: ['孔刘', '郑裕美', '马东锡'],
    description: '证券公司基金管理人石宇光鲜精干，却也是个重利轻义之徒。妻子为此与之决裂，女儿秀安则对如此自私的父亲越来越失望，决定前往釜山和母亲生活。在秀安生日这天，石宇抽出时间陪伴女儿登上开往釜山的特快列车。而与此同时，城市四处出现了极为可疑的暴动事件。政府极力洗白无法掩盖丧尸肆虐的事实，开车的刹那，一名感染者冲入车厢，她很快尸变并对目光所及之处的健康人展开血腥屠杀。未过多久，丧尸便呈几何数爆发性地增长。石宇被迫和幸存者的乘客们在逼仄的空间中奋力求生。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20zombie%20action%20movie%20poster%2C%20intense%20train%20survival%20scene%2C%20dark%20apocalyptic%20atmosphere%2C%20desperate%20characters%20running%2C%20dramatic%20lighting%20from%20train%20windows%2C%20horror%20and%20thriller%20mood%2C%20clean%20cinematic%20composition&width=600&height=850&seq=movie-busan&orientation=portrait',
    tags: ['动作', '丧尸', '惊悚', '灾难'],
    isHot: true,
    isNew: false,
    isClassic: false,
    featured: true,
  },
  {
    id: 'movie-7',
    slug: 'love-letter',
    title: '情书',
    titleEn: 'Love Letter',
    category: 'romance',
    region: 'japanese-movie',
    year: 1995,
    rating: 8.9,
    duration: '117分钟',
    director: '岩井俊二',
    actors: ['中山美穗', '丰川悦司', '柏原崇'],
    description: '日本神户某个飘雪的冬日，渡边博子在前未婚夫藤井树的三周年祭日上又一次悲痛到不能自已。正因为无法抑制住对已逝恋人的思念，渡边博子在其中学同学录里发现藤井树在小樽市读书时的地址时，依循着寄发了一封本以为是发往天国的情书。不想不久渡边博子竟然收到署名为藤井树的回信。经过进一步了解，她知晓此藤井树是一个同她年纪相仿的女孩，且还是男友藤井树少年时代的同班同学。为了多了解一些昔日恋人在中学时代的情况，渡边博子开始与女性藤井树书信往来。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20romantic%20drama%20movie%20poster%2C%20winter%20snowy%20landscape%2C%20nostalgic%20pure%20love%20story%2C%20woman%20in%20white%20snow%2C%20soft%20natural%20light%2C%20minimalist%20Japanese%20aesthetic%2C%20emotional%20and%20gentle%20atmosphere%2C%20film%20photography%20style&width=600&height=850&seq=movie-loveletter&orientation=portrait',
    tags: ['爱情', '文艺', '怀旧', '纯爱'],
    isHot: false,
    isNew: false,
    isClassic: true,
    featured: false,
  },
  {
    id: 'movie-8',
    slug: 'the-wailing',
    title: '哭声',
    titleEn: 'The Wailing',
    category: 'horror',
    region: 'korean-movie',
    year: 2016,
    rating: 8.4,
    duration: '156分钟',
    director: '罗泓轸',
    actors: ['郭度沅', '黄政民', '千玗嬉'],
    description: '在韩国某个偏远的山村，虽然这里生活并不富足，但长久以来安宁无忧，人们仿佛不知危险的逼近。直到某晚，村中突发杀人事件，彻底打破了这里的宁静。在村里担任警察的钟九与同侪迅速赶往现场调查，他初步推断这是一起恶性杀人事件，只不过当地人私下猜测，认为那个不知何时出现在村边树林的日本人有最大嫌疑。随后接二连三的离奇死亡事件发生，各种超自然的现象不断出现。钟九的女儿也开始出现异常症状，钟九不得不寻求巫师一光的帮助。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20movie%20poster%2C%20dark%20supernatural%20thriller%2C%20mysterious%20rural%20village%2C%20ominous%20forest%20atmosphere%2C%20ritual%20and%20exorcism%20theme%2C%20deep%20shadows%20and%20red%20accents%2C%20disturbing%20yet%20artistic%20composition%2C%20minimalist%20Korean%20cinema&width=600&height=850&seq=movie-wailing&orientation=portrait',
    tags: ['恐怖', '悬疑', '超自然', '惊悚'],
    isHot: false,
    isNew: false,
    isClassic: true,
    featured: false,
  },
  {
    id: 'movie-9',
    slug: 'my-sassy-girl',
    title: '我的野蛮女友',
    titleEn: 'My Sassy Girl',
    category: 'comedy',
    region: 'korean-movie',
    year: 2001,
    rating: 8.3,
    duration: '123分钟',
    director: '郭在容',
    actors: ['全智贤', '车太贤'],
    description: '牵牛是个老实巴交的大好人，但他至今还是孑然一身。在一次跟朋友的聚会上，牵牛见到了他心目中的女友——一个外表清丽脱俗的女孩子。碍着朋友的面子，他没有上前认识她。回家的时候，牵牛在地铁车站再次见到了喝醉酒后神志不清的她。她竟在地铁上呼喝男乘客给她让座，又呕向另一名男乘客。牵牛只好带她到旅馆借宿一宵。当他正在洗澡时，警察突然冲入他的房间，一丝不挂的牵牛被带往警署。第二天，她约牵牛出来，盘问一番后，她又再喝醉，牵牛只好再次带她回旅馆过夜。就是如此，两人开始了奇妙的关系。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20movie%20poster%2C%20young%20couple%20in%20playful%20moment%2C%20bright%20and%20cheerful%20atmosphere%2C%20warm%20sunny%20day%2C%20vibrant%20colors%2C%20fun%20and%20romantic%20vibe%2C%20nostalgic%20early%202000s%20Korean%20cinema%20style&width=600&height=850&seq=movie-sassy&orientation=portrait',
    tags: ['喜剧', '爱情', '经典', '浪漫'],
    isHot: false,
    isNew: false,
    isClassic: true,
    featured: false,
  },
  {
    id: 'movie-10',
    slug: 'battle-royale',
    title: '大逃杀',
    titleEn: 'Battle Royale',
    category: 'action',
    region: 'japanese-movie',
    year: 2000,
    rating: 8.3,
    duration: '114分钟',
    director: '深作欣二',
    actors: ['藤原龙也', '前田亚季', '山本太郎'],
    description: '为了培养出忠实效忠于成人、在逆境中坚忍不拔的青少年一代，日本政府出台法令，每年从全国学校随机抽出一个班级的同学，前往荒岛进行生存极限挑战。老师发给学生地图、粮食和各式武器，令他们自相残杀，直到存活下来的最后一个才能离开荒岛。接下来，残暴的游戏规则和令人措手不及的突如其来的死亡，使班上的年轻人互相之间产生了深深的敌意。面对杀害同窗的残酷选择，他们的友情、爱情、信任在生存的本能面前逐渐瓦解。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20action%20thriller%20movie%20poster%2C%20dystopian%20survival%20theme%2C%20students%20on%20deserted%20island%2C%20dark%20intense%20atmosphere%2C%20blood%20red%20title%20on%20black%20background%2C%20brutal%20survival%20game%20concept%2C%20striking%20Japanese%20cinema%20poster%20design&width=600&height=850&seq=movie-battleroyale&orientation=portrait',
    tags: ['动作', '惊悚', '生存', '暴力美学'],
    isHot: false,
    isNew: false,
    isClassic: true,
    featured: false,
  },
  {
    id: 'movie-11',
    slug: 'decision-to-leave',
    title: '分手的决心',
    titleEn: 'Decision to Leave',
    category: 'suspense',
    region: 'korean-movie',
    year: 2022,
    rating: 8.7,
    duration: '138分钟',
    director: '朴赞郁',
    actors: ['汤唯', '朴海日'],
    description: '在山区调查一起谋杀案的刑警海俊遇到了死者的妻子——来自中国的神秘女子瑞莱。瑞莱对丈夫的死没有表现出任何悲伤，这引起了海俊的怀疑。在监视瑞莱的过程中，海俊发现自己逐渐被她吸引，两人之间产生了微妙而危险的情感。随着调查的深入，海俊发现自己陷入了一个精心编织的情感与谎言交织的迷局中，真相与感情变得难以分辨。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20thriller%20movie%20poster%2C%20mysterious%20Chinese%20woman%20and%20Korean%20detective%2C%20foggy%20mountain%20and%20ocean%20landscape%2C%20elegant%20and%20melancholic%20mood%2C%20misty%20blue%20and%20warm%20tones%2C%20sophisticated%20cinematic%20composition%2C%20Park%20Chan%20wook%20style&width=600&height=850&seq=movie-decision&orientation=portrait',
    tags: ['悬疑', '爱情', '犯罪', '文艺'],
    isHot: true,
    isNew: true,
    isClassic: false,
    featured: true,
  },
  {
    id: 'movie-12',
    slug: 'suzume',
    title: '铃芽之旅',
    titleEn: 'Suzume',
    category: 'animation',
    region: 'japanese-movie',
    year: 2022,
    rating: 8.5,
    duration: '121分钟',
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗'],
    description: '生活在日本九州田舍的17岁少女铃芽，遇见了为了寻找"门"而踏上旅途的青年宗像草太。追随着青年的脚步，铃芽来到了山上一片废墟之地，在这里静静伫立着一扇古老的门，仿佛是坍塌中存留的唯一遗迹。铃芽仿佛被什么吸引了一般，将手伸向了那扇门。不久之后，日本各地的门开始一扇一扇地打开。据说，开着的门必须关上，否则灾祸将会从门的那一边降临于现世。星星、夕阳、拂晓，误入之境的天空，仿佛溶解了一切的时间。在神秘之门的引导下，铃芽踏上了关门的旅途。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%2C%20beautiful%20young%20girl%20on%20epic%20journey%2C%20mysterious%20doors%20in%20abandoned%20places%2C%20breathtaking%20Japanese%20landscapes%2C%20stunning%20sky%20and%20sea%20scenery%2C%20Makoto%20Shinkai%20vibrant%20anime%20style%2C%20warm%20dreamlike%20atmosphere&width=600&height=850&seq=movie-suzume&orientation=portrait',
    tags: ['动画', '奇幻', '冒险', '青春'],
    isHot: true,
    isNew: true,
    isClassic: false,
    featured: false,
  },
];

export const siteInfo = {
  name: '日韩影视网',
  description: '日韩影视网提供免费日韩电影在线观看服务，涵盖日本电影免费、韩国电影免费及最新日韩电影。高清画质急速播放，经典大片和新片速递一网打尽。',
  keywords: '日韩影视网,日韩电影在线,免费日韩电影,日韩电影高清,韩国电影免费,日本电影免费,最新日韩电影,高清流畅,急速播放',
  url: 'https://www.rihanyingshi.com',
  email: 'contact@rihanyingshi.com',
  about: {
    intro: '日韩影视网成立于2020年，是国内领先的日韩电影免费在线观看平台。我们致力于为广大影迷提供最新、最全、最高清的日本电影和韩国电影资源。无论是经典老片还是最新上映的大片，在这里都能找到。',
    mission: '我们的使命是打破语言和地域的壁垒，让每一位华语观众都能轻松欣赏到优质的日韩影视作品。我们相信，好的电影能够跨越国界，传递情感与价值。',
    features: [
      { title: '海量片库', description: '收录超过5000部日本和韩国电影，涵盖爱情、动作、悬疑、动画、喜剧、恐怖等多种类型，定期更新最新影片。' },
      { title: '高清画质', description: '提供1080P全高清画质，支持多种清晰度选择，确保观众获得最佳的视觉体验。' },
      { title: '极速播放', description: '采用先进的CDN加速技术，确保影片流畅播放，告别卡顿和缓冲困扰。' },
      { title: '完全免费', description: '所有影片均免费观看，无需注册、无需付费，让好电影触手可及。' },
    ],
    stats: [
      { label: '影片总数', value: '5,000+' },
      { label: '日活跃用户', value: '50万+' },
      { label: '累计播放', value: '10亿+' },
      { label: '用户好评率', value: '98%' },
    ],
  },
};

export const testimonials = [
  {
    id: 1,
    name: '电影爱好者小李',
    avatar: 'https://readdy.ai/api/search-image?query=East%20Asian%20young%20man%20portrait%20avatar%2C%20professional%20headshot%2C%20neutral%20background%2C%20warm%20lighting%2C%20friendly%20expression&width=100&height=100&seq=avatar-1&orientation=squarish',
    content: '日韩影视网是我每天必逛的网站！片源真的很全，想看的日本动画电影和韩国大片基本都能找到，画质也超棒。强烈推荐给喜欢日韩电影的朋友们！',
    rating: 5,
  },
  {
    id: 2,
    name: '韩剧迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=East%20Asian%20young%20woman%20portrait%20avatar%2C%20professional%20headshot%2C%20neutral%20background%2C%20soft%20lighting%2C%20warm%20smile&width=100&height=100&seq=avatar-2&orientation=squarish',
    content: '太爱这个网站了！韩国电影更新速度很快，新片上线基本同步。播放不卡顿，清晰度也很高。已经推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    id: 3,
    name: '影评人老张',
    avatar: 'https://readdy.ai/api/search-image?query=East%20Asian%20middle%20aged%20man%20portrait%20avatar%2C%20professional%20headshot%2C%20neutral%20background%2C%20studio%20lighting%2C%20confident%20look&width=100&height=100&seq=avatar-3&orientation=squarish',
    content: '作为一个影评人，我对电影资源的质量要求很高。日韩影视网的影片分类清晰，搜索方便，而且影片的画质和字幕质量都相当不错。值得信赖的平台。',
    rating: 4,
  },
  {
    id: 4,
    name: '二次元少女小陈',
    avatar: 'https://readdy.ai/api/search-image?query=East%20Asian%20young%20woman%20portrait%20avatar%2C%20fresh%20and%20natural%20style%2C%20neutral%20background%2C%20soft%20lighting%2C%20genuine%20smile&width=100&height=100&seq=avatar-4&orientation=squarish',
    content: '日本动画电影收藏超全！宫崎骏全集、新海诚三部曲都能找到，画质都是高清的，而且还有中文字幕。对于喜欢日本动画电影的我来说简直是宝藏网站！',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '日韩影视网的电影是否需要付费观看？',
    answer: '完全不需要！日韩影视网所有电影均免费在线观看，无需注册账号，无需支付任何费用。我们致力于让每一位影迷都能轻松欣赏优质的日韩电影。',
  },
  {
    question: '网站的电影画质如何？',
    answer: '我们提供1080P全高清画质，并支持多种清晰度选择。采用先进的视频编码和CDN加速技术，确保您获得流畅、清晰的观影体验。',
  },
  {
    question: '影片更新频率是怎样的？',
    answer: '我们的内容团队每天都会更新影片库，日本和韩国的最新上映电影会在第一时间上线。同时，我们也在不断补充经典老片，丰富片库内容。',
  },
  {
    question: '需要下载播放器才能观看吗？',
    answer: '不需要！日韩影视网支持网页端直接播放，无需下载任何播放器或插件。使用Chrome、Safari、Edge等主流浏览器即可流畅观看。',
  },
  {
    question: '可以在手机上观看吗？',
    answer: '当然可以！我们的网站完美适配手机、平板和电脑等多种设备，无论您在哪里，都能享受优质的观影体验。',
  },
];